import { useQuery } from "react-query";
import { useHttp } from "../providers/http";
import dayjs from "dayjs";

const useAvailabilities = (shopId, ...callbacks) => {
    const http = useHttp();
    return useQuery(["availabilities", shopId], () => {
        const url = `/shops/${shopId}/availability/${dayjs().toISOString()}/${dayjs().add(3, 'month').toISOString()}`
        return http.get(url)
            .then(response => {
                return response.data
            })
            .catch(err => {
                throw err;
            })
    }, {
        enabled: !!shopId
    })
}

export default useAvailabilities;